/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {requestPrivacyDeletion} from '../api'

export const useMutationRequestPrivacyDeletion = createReactQueryMutationHook('requestPrivacyDeletion', requestPrivacyDeletion)
